export const inputResolutions = {
    "360p": [640, 360],
    "144p": [256, 144],
    "96p": [160, 96],
};
